import { DamageCategoryResponse } from "@/main/models/response/damageCategoryResponse";
export enum DamageCategoryTypes {
	GET_DAMAGE_CATEGORIES = "@damageCategory/GET_DAMAGE_CATEGORIES",
	SAVE_DAMAGE_CATEGORIES = "@damageCategory/SAVE_DAMAGE_CATEGORIES",
	RESET_REDUCER_DAMAGE_CATEGORIES = "@damageCategory/RESET_REDUCER_DAMAGE_CATEGORIES",
}

export interface DamageCategoryState {
	readonly damageCategories: {
		data: DamageCategoryResponse[] | null;
		errorMessages: string[] | null;
		isError: boolean;
		isLoading: boolean;
	};
}

export interface GetDamageCategories {
	type: typeof DamageCategoryTypes.GET_DAMAGE_CATEGORIES;
	payload: {
		guidInsurer: string;
	};
}

export interface SaveDamageCategories {
	type: typeof DamageCategoryTypes.SAVE_DAMAGE_CATEGORIES;
	payload: {
		data: DamageCategoryResponse[] | null;
		isError: boolean;
		errorMessages: string[] | null;
	};
}

export interface ResetReducerDamageCategories {
	type: typeof DamageCategoryTypes.RESET_REDUCER_DAMAGE_CATEGORIES;
}

export type DamageCategoryActionTypes = GetDamageCategories | SaveDamageCategories | ResetReducerDamageCategories;
